import header from "./factsheet-example.webp";
import section1 from "./zeichnung-eines-grundstueckes.jpg";
import section2 from "./real-estate-agent-with-plans.jpg";
import section3 from "./factsheet-on-tablet.png";
import section4 from "./steps-factsheet.webp";
import section5 from "./close-up-architect-designing-plans.jpg";
import section6 from "./designer-discusses-project-with-customers.jpg";
import section7 from "./factsheet-examples.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
